<template>
    <div class="mainWork">
        <div class="myMenu" style="position: unset;">
            <div class="priority">执法管理</div>
            <div @click="personList" v-if="command=='超级管理员' || command=='高级管理员'">人员管理</div>
            <div @click="unitList" v-if="command=='超级管理员' || command=='高级管理员'">单位管理</div>
        </div>

        <div class="formBox">
            <el-form ref="myForm" :model="query" size="small">
                <span class="formBoxItem">
                    <el-form-item label-width="80px" label="执法编号" prop="recordNo">
                        <el-input v-model="query.recordNo" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label-width="80px" label="联系方式" prop="telephone">
                        <el-input v-model="query.telephone" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label-width="80px" label="当事人" prop="partyName">
                        <el-input v-model="query.partyName" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label-width="80px" label="车牌号" prop="carPlate">
                        <el-input v-model="query.carPlate" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label-width="80px" label="驾驶证号" prop="cardCode">
                        <el-input v-model="query.cardCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <!-- <el-form-item label-width="80px" label="状态" prop="status">
                        <el-select placeholder="请选择" v-model="query.status">
                            <el-option v-for="item in statusLists" :key="item.id" :label="item.label" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <div style="margin-left:10px">
                        <el-button type="primary" size="small" @click="getAccidentList">查询</el-button>
                    </div>
                </span>
            </el-form>
        </div>
        
        <div class="table">
            <el-table :data="accidentList" max-height="460" border tooltip-effect="dark" style="width: 100%" :header-cell-style="tableHeaderColor" ref="multipleTable" :cell-style="cellStyle">
                <el-table-column label="执法编号" show-overflow-tooltip min-width="160">
                    <template slot-scope="scope">
                        {{scope.row.recordNo}}
                    </template>
                </el-table-column>
                <el-table-column label="执法位置" show-overflow-tooltip min-width="140">
                    <template slot-scope="scope">
                        {{scope.row.location}}
                    </template>
                </el-table-column>
                <el-table-column label="姓名" show-overflow-tooltip min-width="70">
                    <template slot-scope="scope">
                        {{scope.row.partyName}}
                    </template>
                </el-table-column>
                <el-table-column label="当事人手机号" show-overflow-tooltip min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.telephone}}
                    </template>
                </el-table-column>
                <el-table-column label="车牌号" show-overflow-tooltip min-width="80">
                    <template slot-scope="scope">
                        {{scope.row.carPlate}}
                    </template>
                </el-table-column>
                <el-table-column label="驾驶证号" show-overflow-tooltip min-width="150">
                    <template slot-scope="scope">
                        {{scope.row.cardCode}}
                    </template>
                </el-table-column>
                <el-table-column label="状态" show-overflow-tooltip min-width="100">
                    <template slot-scope="scope">
                        {{scope.row.status | orderListFilter}}
                    </template>
                </el-table-column>
                <el-table-column label="执法人" show-overflow-tooltip min-width="70">
                    <template slot-scope="scope">
                        {{scope.row.realName}}
                    </template>
                </el-table-column>
                <el-table-column label="执法时间" show-overflow-tooltip min-width="140">
                    <template slot-scope="scope">
                        {{scope.row.createTime}}
                    </template>
                </el-table-column>
                <el-table-column label="取消原因" show-overflow-tooltip min-width="80">
                    <template slot-scope="scope">
                        {{scope.row.cancelReason}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" min-width="200">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status < 3">
                            <span class="reMessage" @click="onQzhifa(scope.row)">取消执法</span>
                            <span @click="getRoomId(scope.row.id, '', '')">进入处理</span>
                        </template>
                        <template v-else>
                            <span style="padding-left: 20px;" @click="getRoomId(scope.row.id, '', '')">详情</span>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination" v-if="accidentList.length">
                <nt-pagination ref="child" @fetchData="getMyAccidentList"></nt-pagination>
            </div>
        </div>

        <transition>
            <videoPlat ref="videoPlat" v-if="AddAffairShow" :roomId="roomId" :videoDirect="videoDirect" :videoSource="videoSource" @reStartMask="reStartMask" @closeMask="closeMask" @startMethod="startMethod"></videoPlat>
        </transition>

        <el-dialog title="取消执法原因" center :visible.sync="dialogVisible" :close-on-click-modal="false" :append-to-body="true">
            <el-form ref="dialogForm" :model="dialogModel" size="small">
                <el-form-item prop="reason">
                    <el-select style="width: 100%;" placeholder="请选择取消执法类型" v-model="dialogModel.reason">
                        <el-option v-for="item in typeLists" :key="`${item.id}`" :label="item.label" :value="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="remark">
                    <el-input placeholder="请填写取消执法原因" type="textarea" :rows="5" v-model="dialogModel.remark"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="onCancel">取消</el-button>
                <el-button type="primary" @click="onConfirm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from "vuex"
import config from "@/common/env"
import videoPlat from "./video"

export default {
    name: 'workPlat',
    components: {
        videoPlat,
    },
    data() {
        return {
            hasAlreadyEnter: {},
            AddAffairShow: false,
            roomId: null,
            accidentList: [],
            videoDirect: false,
            videoSource: 0, // ali video

            query: {
                recordNo: null,
                telephone: null,
                partyName: null,
                carPlate: null,
                cardCode: null,
                status: null,
                page: 1,
                size: 10
            },

            statusLists: [
                {id: null, label: "全部"},
                {id: 1, label: "小程序新建未处理"},
                {id: 2, label: "暂存"},
                {id: 3, label: "全流程完成"},
                {id: 4, label: "处置终止"},
                {id: 5, label: "手动取消"},
                // {id: 6, label: "超时取消"},
            ],

            dialogVisible: false,
            typeLists: [
                {id: "1", label: "行驶证核验未通过"},
                {id: "2", label: "身份证核验未通过"},
                {id: "3", label: "驾驶证核验未通过"},
            ],
            dialogModel: {
                reason: null,
                remark: null 
            },
            

        }
    },
    computed: {
        ...mapState(['onlineStatus', 'command', 'myAccidentList']),

    },
    created() {
        
    },
    mounted() {
        this.getAccidentList();
        
    },
    beforeDestroy() {
        
    },
    methods: {

        onQzhifa(row) {
            console.log(row)
            this.dialogVisible = true;
            this.roomId = row.id;
        },
        onCancel() {
            this.$refs["dialogForm"].resetFields();
            this.dialogVisible = false;
        },
        onConfirm() {
            if(this.dialogModel.remark == null || this.dialogModel.remark == "") {
                return this.$message.error("请填写取消执法原因")
            }
            this.$axios.post(`/admin/enforcement/cancel`, {
                recordId: this.roomId,
                reason: this.dialogModel.reason,
                remark: this.dialogModel.remark
            }).then(res => {
                let datas = this.AppUtils.checkResponse(res);
                let { code, data, msg } = datas;
                if(code == 0) {
                    this.dialogVisible = false;
                    this.$message.success("取消执法成功");
                    this.$refs["dialogForm"].resetFields();
                    this.getMyAccidentList();
                } else {
                    this.$message.error(msg);
                }
            })
        },
        

        getAccidentList() {
            this.query.page = 1;
            this.query.size = 10;
            this.getMyAccidentList();
        },
        getMyAccidentList(args) {
            if (args) {
                if (args.page) { //分页
                    this.query.page = args.page; //当前页数
                    this.query.size = args.pageSize; //每页显示多少条
                }
            }

            this.$axios.post('/admin/enforcement/list', this.query).then(res => {
                let data = this.AppUtils.checkResponse(res);
                if (data.code == 0) {
                    this.accidentList = data.data.list;
                    if(this.accidentList.length > 0) {
                        this.$nextTick(() => {
                            this.$refs.child.initPage(data.data.total, this.query.page, this.query.size)
                        })
                    }
                } else {
                    this.$message.error(data.msg);
                }
            })
        },
        getRoomId(id, videoDirect, source) {
            let myAccidentList = [];
            let filterRes = this.accidentList.filter(accident => accident.id == id);
            let filterResMy = myAccidentList.filter(accident => accident.id == id);
            if (filterRes.length) {
                if (!filterResMy.length) {
                    myAccidentList.push(filterRes[0]);
                    this.$store.commit('MyAccidentList', myAccidentList);
                }
            }

            this.videoSource = source == 1 ? 1 : 0; // ali video
            this.videoDirect = videoDirect;
            this.roomId = id;
            let key = 'enter' + id;
            if (!this.hasAlreadyEnter[key]) {
                sessionStorage.setItem('isShowView','')
                this.hasAlreadyEnter[key]=1;
            } else {
                
            }
            this.canEdit(id);
        },
        canEdit(accidentId) {
            this.$axios.get(`/admin/enforcement/handle/${accidentId}`).then(res => {
                console.log(res)
                if (res.data.code == 0) {
                    this.AddAffairShow = true;
                } else if (res.data.code == 107003) {
                    this.$confirm(res.data.msg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        
                    }).catch(() => {

                    })
                } else {
                    this.$message.error(res.data.msg);
                }
            })
        },


        // **************************************************************************
        closeMask() {
            this.AddAffairShow = false;
        },

        reStartMask(id) {
            let that = this;
            this.$nextTick(() => {
                that.$refs.videoPlat.getAccidentList();
            })
        },
        
        startMethod() {
            this.getAccidentList();
        },

        personList() {
          this.$router.push('/staff');
            // window.open('/staff', this.getWindowName('staff')).focus();
        },
        unitList() {
          this.$router.push('/unit');
            // window.open('/unit', this.getWindowName('unit')).focus();
        },  

        cellStyle({  row,  column, rowIndex, columnIndex }) {
            return 'height:10px';
        },
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #f4f5f7;color: #333;text-indent:5px'
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.mainWork {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 20px;
    overflow: hidden;

    .table {
        width: 100%;
        padding: 20px 0 0 0;
        background: #fff;

        span {
            font-size: 14px;
            font-family: PingFangSC, PingFangSC-Regular;
            font-weight: 400;
            text-align: left;
            color: #1e4682;
            cursor: pointer;
        }

        .reMessage {
            box-sizing: border-box;
            padding-left: 20px;
            border-right: 1px solid #ccc;
            padding-right: 15px;
            margin-right: 15px;
        }
    }
}

.priority {
    background-color: rgb(157, 197, 240);
    color: rgb(6, 135, 241) !important;
}

.table /deep/ .cell {
    padding-left: 0;
}
.table /deep/ .el-tooltip {
    width: auto!important;
}
.table /deep/ .el-table .cell {
    padding: 0;
}

.formBox {
	width: 100%;
    // position: absolute;
    // left: 20px;
    // top: 75px;
    padding: 15px 0 0;
    margin: 20px auto;
    background: #fff;
}
.formBoxItem {
    width: 100%;
    display: flex;
    flex-flow: wrap;
}

</style>



// WEBPACK FOOTER //
// workPlat.vue?32398bdc